import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
export default function PressureTriggerCount({ deviceId }) {
  const { user } = useAuth() || {};
  const { t } = useLang();
  const [count, setCount] = useState(null);
  useEffect(() => {
    let active = true, busy = false;
    setCount(null);
    const read = async () => {
      if (busy) return;
      busy = true;
      try { const { data } = await api.get(`/pressure/v1/devices/${deviceId}/trigger-summary`); if (active) setCount(data.count); }
      catch { if (active) setCount(null); }
      finally { busy = false; }
    };
    read(); const timer = setInterval(read, 30000);
    return () => { active = false; clearInterval(timer); };
  }, [deviceId, user?.id, user?.role, user?.organization_id]);
  return <div title={t("Alle geregistreerde druktriggers in de bewaarde historie; verwijderde events en historie tellen niet mee.", "All recorded pressure triggers in retained history; excluded events and history are omitted.")} className="mt-0.5 font-mono text-lg font-semibold">{count ?? "—"}</div>;
}
